module.exports = __webpack_public_path__ + "media/inserate/assets/images/small-37f73ba1c84d0f737b11b7de8ce05ef0.png";